module.exports = "<p>\n  manning-agency-base works!\n</p>\n"